import React, { useState, useEffect, } from "react";
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    '@keyframes blinker': {
        '50%': {
            opacity: '0.5',
        },
        '100%': {
            opacity: '1',
        }
    },
    timerContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
    mainTimer: {
        fontSize: '12px',
        padding: '0px 2px',
        borderRadius: '0px 0px 4px 4px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
    },
    blink: {
        animationName: 'blinker',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(1, 2, 0, 1)',
        animationDuration: '1.5s',
    }
}, { name: 'Timer' });
const Timer = ({ t, deltaTimeMs }) => {
    if (!t)
        return null;
    const { v: value, acTm: activatedTime = 0, ccw: counterClockWise, st: stateTimer } = t || {};
    const startTimeFormulaIfPaused = value * 1000;
    const startTimeFormulaIfActive = value * 1000 + (Date.now() - activatedTime) * (counterClockWise ? -1 : 1);
    const [timerStamp, setTimerStamp] = useState(activatedTime
        ? startTimeFormulaIfActive
        : startTimeFormulaIfPaused);
    useEffect(() => {
        const interval = setInterval(() => {
            if (activatedTime) {
                const currentServerTime = Date.now() - deltaTimeMs;
                const elapsedMs = currentServerTime - activatedTime;
                const timerStateFormulaMs = value * 1000 + elapsedMs * (counterClockWise ? -1 : 1);
                setTimerStamp(timerStateFormulaMs >= 0 ? timerStateFormulaMs : timerStamp);
            }
            else {
                setTimerStamp(value * 1000);
            }
        }, 500);
        return () => {
            clearInterval(interval);
        };
    }, [activatedTime, value, counterClockWise, deltaTimeMs]);
    const st = useStyles();
    const timerValueS = Math.floor(timerStamp / 1000);
    const minutes = Math.floor(timerValueS / 60);
    const seconds = timerValueS - minutes * 60;
    const time = `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    // const time = `${minutes < 10 ? `0${minutes}` : minutes}:00`;
    return (<div className={st.timerContainer}>
      <div className={`${st.mainTimer}`}>
        {<div className={`${stateTimer !== 1 ? st.blink : ''}`}>
          {time.startsWith('0-') ? '' : time}
        </div>}
      </div>
    </div>);
};
export default Timer;



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/Timer/index.jsx